import React, { Component }from 'react';
import ContentWrapper from '../../components/Layout/ContentWrapper';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import { UI_HEIGHT, BACKGROUND_COLOR } from '../Common/constants';
import { Grid, Row, Col, Panel, Button, Table } from 'react-bootstrap';
import { Link } from 'react-router';
import Spinner from '../../components/Widgets/spinner';
import { Translate, Localize } from 'react-redux-i18n';
//import {buttonStyle} from '../Common/style'

class RowRenderer extends Component {
    setScrollLeft(scrollBy) {
        // To freeze couple columns
        this.refs.row.setScrollLeft(scrollBy);
    }

    getRowStyle() {
        return {
            color: this.getRowBackground()
        }
    }


    getRowBackground() {
      return this.props.row.InStock > 0 ? BACKGROUND_COLOR.blue : BACKGROUND_COLOR.red
    }
    render() {
        //here we are just changing the style
        //but we could replace this with anything we liked, cards, images, etc
        //usually though it will just be a matter of wrapping a div, and then calling back through to the grid
        return (<div style={this.getRowStyle() }><ReactDataGrid.Row ref="row" {...this.props} /></div>)
    }
}

class InventoryLowStock extends Component {
    static contextTypes = {
        router: React.PropTypes.object
    };

    constructor() {
        super();
        this.state = {
            tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,

            rows: [],
            selectedRows: null,
            editedRows: [],
            filters: {},
            sortColumn: null,
            sortDirection: null,
            gourpOpen: false
        };

        this.handleResize = this.handleResize.bind(this);
        this.zoneLevel = this.zoneLevel.bind(this);
    }

    componentDidMount() {
        window.addEventListener('resize', this.handleResize);
        this.props.fetchLowStockInventoryInventories();
    }

    componentDidUpdate() {
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize);
    }

    // Once inventories is ready, reset state.

    componentWillReceiveProps(nextProps) {
        const PT = nextProps.inventories;
        if (nextProps.inventories && nextProps.inventories != this.props.inventories) {
            let newInventories = [...nextProps.inventories];
            newInventories.map(inventory => {
              inventory["ProductName"] = inventory["ProductNum"].Name;
              inventory["Description"] = inventory["ProductNum"].Description;
              inventory["PackageSize"] = inventory["ProductNum"].PackageSize;
              inventory["LowestAmount"] = inventory["ProductNum"].MinStockRange;
              inventory["ProductNum"] = inventory["ProductNum"].ProductNum;
              // inventory["Warehouse"] = inventory["Warehouse_id"].Name;
            })
            this.setState({
                rows: newInventories
            });
        }
    }

    handleResize(e) {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton });
    }

    // Set inventories being selected to be currentInventory and navigate user to the edit page
    // test

    setCurrentInventory(e) {
        e.preventDefault();
        const currentInventory = this.state.selectedRows[0];
        this.props.selectInventory(currentInventory);
    }

    clickNew(e) {
        e.preventDefault();
        this.props.resetCurrentInventory();
    }

    zoneLevel(e) {
      e.preventDefault();
      const currentInventory = this.state.selectedRows[0];
      this.props.resetCurrentInventory();
      this.props.selectInventory(currentInventory);
      this.context.router.push('/inventories/detail/');
    }

    // Render the table head and bind it to the datatable plugin to show a sortable and searchable table.

    renderTable() {
        if (this.props.isLoading && !this.props.error) return <Spinner/>
        else if (this.props.error) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.error)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the row select function

            const onRowSelect = rows => {
                this.setState(...this.state, { selectedRows: rows });
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            const handleFilterChange = filter => {
                let newFilters = Object.assign({}, this.state.filters);
                if (filter.filterTerm) {
                    newFilters[filter.column.key] = filter;
                } else {
                    delete newFilters[filter.column.key];
                }
                this.setState({ filters: newFilters });
            }


            // Handle the editable function

            const handleRowUpdated = e => {
                // merge updated row with current row and rerender by setting state
                let rows = this.state.rows.slice(0);
                let editedRows = this.state.editedRows.slice(0);
                Object.assign(rows[e.rowIdx], e.updated);
                // if the element is already edited, remove the old one.
                editedRows.forEach((element, index) => {
                    if (element.Product_id === rows[e.rowIdx].Product_id)
                        editedRows.splice(index, 1)
                }, this);
                // push the row into the editedRows array
                editedRows.push(rows[e.rowIdx]);
                this.setState({
                    rows: rows,
                    editedRows: editedRows
                });
            }

            //Custom Formatter component
            const IsEnabledFormatter = React.createClass({
                render() {
                    if (this.props.value) return <span className="label label-success"><Translate value="enabled" /></span>;
                    else return <span className="label label-danger"><Translate value="disable" /></span>;
                }
            });

            // Column difinition

            const columns = [
              {
                  key: 'ProductNum',
                  name: <Translate value="product_num" /> ,
                  resizable: true,
                  sortable: true,
                  width: 120,
                  filterable: true
              },
              {
                  key: 'ProductName',
                  name: <Translate value="product_name" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
                  filterable: true
              },
              {
                  key: 'PackageSize',
                  name: <Translate value="package_size" />,
                  resizable: true,
                  sortable: true,
                  width: 150,
                  filterable: true
              },
              {
                  key: 'Description',
                  name: <Translate value="description" />,
                  resizable: true,
                  sortable: true,
                  width: 150,
                  filterable: true
              },
              {
                  key: 'RefPurchasingPrice',
                  name: <Translate value="refer_purchasing_price" />,
                  resizable: true,
                  sortable: true,
                  width: 150,
                  filterable: true
              },
              {
                  key: 'InStockPrice',
                  name: <Translate value="avg_in_stock_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 150,
                  filterable: true
              },
              {
                  key: 'InStock',
                  name: <Translate value="instock" />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  filterable: true
              },
              {
                  key: 'PreSale',
                  name: <Translate value="presale" />,
                  resizable: true,
                  sortable: true,
                  width: 70,
                  filterable: true
              },
              {
                  key: 'Purchased',
                  name: <Translate value="purchased" />,
                  resizable: true,
                  sortable: true,
                  width: 90,
                  filterable: true
              },
              {
                  key: 'LowestAmount',
                  name: <Translate value="lowest_amount" />,
                  resizable: true,
                  sortable: true,
                  width: 150,
                  filterable: true
              },
              {
                  key: 'Warehouse',
                  name: <Translate value="warehouse" />,
                  resizable: true,
                  sortable: true,
                  width: 200,
                  filterable: true
              },
            ]

            return (
                <Row><Col sm={ 12 }><div style={{ maxWidth: '99%' }} id="InventoryLowStock-dataGrid1">
                    <ReactDataGrid
                        rowRenderer={RowRenderer}
                        rowKey='id'
                        onGridSort={handleGridSort}
                        toolbar={<Toolbar enableFilter={true}/>}
                        onAddFilter={handleFilterChange}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        minHeight={this.state.tableHeight}
                        onRowUpdated={handleRowUpdated}
                        enableRowSelect='single'
                        onRowSelect={onRowSelect}
                        />
                </div></Col></Row>
            )
        }
    }

    render() {
        return (
            <ContentWrapper>
                <div className="content-heading"><Translate value="low_stock_inventories" /></div>
                <Row><Col sm={ 12 }>
                    <Link to="/inventories"  className="btn btn-green marginLeftStyle"  ><em className="fa fa-mail-reply"/></Link>
                    <Link to="/inventories/relocation" type="button" className="btn btn-primary marginLeftStyle">
                        <em className="icon-hourglass marginRightStyle"/><Translate value="inventory_relocation" />
                    </Link>
                    <Link to="/inventories/adjustment" type="button" className="btn btn-primary marginLeftStyle">
                        <em className="icon-envelope-letter marginRightStyle"/><Translate value="inventory_adjustment" />
                    </Link>
                    <Button className="btn btn-primary marginLeftStyle"
                      disabled={!this.state.selectedRows || this.state.selectedRows.length != 1}
                      onClick={this.zoneLevel}>
                      <Translate value="zone_level" />
                    </Button>
                </Col></Row>
                <br/>
                {this.renderTable() }
                <br/>
                <br/>
                <Row>
                    <Col sm={ 2 }>
                        <Col sm ={3}><div className="iconblue"/></Col>
                        <Col sm={ 9 }><Translate value="on_stock" /></Col>
                    </Col>
                    <Col sm={ 2 }>
                        <Col sm ={3}><div className="iconred"/></Col>
                        <Col sm={ 9 }><Translate value="off_stock" /></Col>
                    </Col>
                </Row>

            </ContentWrapper>
        );
    }
}



export default InventoryLowStock;



// WEBPACK FOOTER //
// ./master/jsx/components/Inventories/inventoryLowStock.jsx